import { render, staticRenderFns } from "./RankingLabel.vue?vue&type=template&id=450f0ce6&"
import script from "./RankingLabel.vue?vue&type=script&lang=ts&"
export * from "./RankingLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports